import React, {useEffect, useState} from 'react';
import {Slider, LazyImage, Nav, HomeHeader} from "../../Components";
import {  MallLandData} from "../Home/HomeServices";
import "../Home/Home.scss";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {CampaignList, MyRecentMerchant, RewardList} from "../Home/Sections";
import {MyInvoiceList} from "../Home/Sections/MyInvoiceList";
import {Modal} from 'antd';
import 'antd/dist/antd.css';
import ReactPlayer from 'react-player'
import {MyRecentMerchantMenu} from "../Home/Sections/MyRecentMerchantMenu";
import {MultipleList} from "../Home/Sections/MultipleList";
import "./InnerLand.scss";
import VideoSec from "../Home/Sections/VideoSec";
import AudioSec from "../Home/Sections/AudioSec";
import PollSec from "../Home/Sections/pollSec";
import SeeMore from "../Home/Sections/SeeMore";
import {ProductRegal} from "../../Components/ProductRegal/ProductRegal";
import {CheckinMallAuth, getAccessToken_api} from "../../Services/apis";
import {useDispatchMall, useDispatchUser} from "../../hooks";
import ActualSec from "../Home/Sections/ActualSec";
import CategorySliderSec from "../Home/Sections/CategorySliderSec";
import TagBannerSec from "../Home/Sections/TagBannerSec";
import BlogSec from "../Home/Sections/BlogSec";


function InnerLand() {

    //hooks
    const location = useLocation();
    const history = useHistory();
    const {merchantiId,pageiId  } = useParams();
    const setUser = useDispatchUser();
    const setMall = useDispatchMall();

    const [mallName,setMallName] = useState("");

    const [loading,setLoading] = useState(true);
    const [status,setStatus] = useState("default");


    //states
    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);

    //fab btns
    const [isOpen, set_isOpen] = useState(false);

    const [button_list, set_button_list] = useState([]);
    const [button_list2, set_button_list2] = useState([]);
    const [slider, set_slider] = useState([]);
    const [single_bar, set_single_bar] = useState([]);
    const [banner, setBanner] = useState([]);
    const [dual_bar, set_dual_bar] = useState([]);
    const [dual_bar_a, set_dual_bar_a] = useState([]);
    const [triad_big_left, set_triad_big_left] = useState([]);

    const [left, set_left] = useState({});
    const [right_top, set_right_top] = useState({});
    const [right_bottom, set_right_bottom] = useState({});

    const [right, set_right] = useState({});
    const [left_top, set_left_top] = useState({});
    const [left_bottom, set_left_bottom] = useState({});

    const [homi, setHomi] = useState([]);
    const [pageData, set_pageData] = useState(null);
    const [notifHint, setNotifHint] = useState(false);


    //coupon
    const [coupon, set_coupon] = useState("");
    const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);
    const [live, set_live] = useState(false);
    const [modalSW, set_modalSW] = useState(true);
    const [liveSrc, set_liveSrc] = useState("https://live.cdn.asset.aparat.com/b9bec55bfc3c464f980e5050441b7b19/livehls/esfahan_shora_musQ1_480p/1625985336500.ts?s=psDpYNA52DT4QITR-_eGDw&e=1626006161&ip=89.43.11.51");



    Array.prototype.sortBy = function(p) {
        return this.slice(0).sort(function(a,b) {
            return (a[p] > b[p]) ? 1 : (a[p] < b[p]) ? -1 : 0;
        });
    }


    try {
        useEffect(() => {
            let search = new URLSearchParams(location.search)
            let token = search.get('token');
            let userId = search.get('user_uid');
            console.log(token,userId);
            getHome();
        }, [])


        //Set Home
        const setHome = (home) => {

            let yy = home.data.sections.sortBy('order');
            // console.log("Home",yy)

             // yy.push({section_type:"blog_sec",order:2,items:[]})
            setHomi(yy)


            //find data ---
            let button_list_loc = home.data.sections.find(data => data.section_type === "button_list");
            let button_list2_loc = home.data.sections.filter(data => data.section_type === "button_list");
            let slider_loc = home.data.sections.find(data => data.section_type === "slider");
            let single_bar_loc = home.data.sections.filter(data => data.section_type === "single_bar");
            let dual_bar_loc = home.data.sections.find(data => data.section_type === "dual_bar");
            let dual_bar_a_loc = home.data.sections.filter(data => data.section_type === "dual_bar");
            // console.log("Dual : ",dual_bar_a_loc)
            let triad_big_left_loc = home.data.sections.find(data => data.section_type === "triad_big_left");
            let triad_big_right_loc = home.data.sections.find(data => data.section_type === "triad_big_right");
            let banner_loc = home.data.sections.find(data => data.section_type === "single_banner");

            if (dual_bar_a_loc) {
                set_dual_bar_a(dual_bar_a_loc)
            }

            // set States
            if (banner_loc) {
                setBanner(banner_loc.items);
            }

            if (button_list_loc) {
                set_button_list(button_list_loc.items)
            }

            if (button_list2_loc) {
                set_button_list2(button_list2_loc)
            }


            if (slider_loc) {
                set_slider(slider_loc.items)
            }
            if (single_bar_loc) {
                let items = single_bar_loc.map(item=>item.items[0]);
                set_single_bar(items)
            }

            if (dual_bar_loc) {
                set_dual_bar(dual_bar_loc.items)
            }


            if (triad_big_left_loc) {
                set_triad_big_left(triad_big_left_loc.items)
            }








            if (triad_big_left_loc) {
                let left_loc = triad_big_left_loc.items.find(data => data.position === "left");
                let left_top_loc = triad_big_left_loc.items.find(data => data.position === "right_top");
                let left_bottom_loc = triad_big_left_loc.items.find(data => data.position === "right_bottom");
                if (left_loc) {
                    set_left(left_loc)
                }
                if (left_top_loc) {
                    set_left_top(left_top_loc)
                }
                if (left_bottom_loc) {
                    set_left_bottom(left_bottom_loc)
                }
            }


            if (triad_big_right_loc) {
                let right_loc = triad_big_right_loc.items.find(data => data.position === "right");
                let right_top_loc = triad_big_right_loc.items.find(data => data.position === "left_top");
                let right_bottom_loc = triad_big_right_loc.items.find(data => data.position === "left_bottom");
                if (right_loc) {
                    set_right(right_loc)
                }
                if (right_top_loc) {
                    set_right_top(right_top_loc)
                }
                if (right_bottom_loc) {
                    set_right_bottom(right_bottom_loc)
                }
            }


        }

        const getHome = async () => {
            const localMallId = localStorage.getItem('mallId')
            if(localMallId && merchantiId && pageiId) {

                try {
                    let home = await MallLandData(localMallId,merchantiId,pageiId);
                    set_pageData(home.data)
                    setHome(home);
                    setPreload(false);

                } catch (e) {
                    setPreload(false);
                }
            }
        }


        const LinkDispatcher = (link,obj) => {
            switch (link) {
                case 'mall_campaigns':
                    history.push('/festivals')
                    break;
                case 'mall_campaign_details':
                    history.push(`/festival-detail/${obj.link_to_uid}`,{festival:{uid:obj.link_to_uid}})
                    break;
                case 'my_rewards':
                    history.push('/reward')
                    break;
                case 'mall_merchant_details':
                    history.push(`/store-detail/${obj.link_to_uid}`,{store:{uid:obj.link_to_uid}})
                    // history.push('/store')
                    break;
                case 'merchant_online_store':
                    let mallID = localStorage.getItem("mallId");
                    //window.location.href = `https://www.digimaall.com/malls/${mallID}/merchants/${obj.link_to_uid}`;
                    // window.open(
                    //     `https://${window.location.host}/download/${mallID}/merchants/${obj.link_to_uid?obj.link_to_uid:""}`,
                    //
                    //     '_blank' // <- This is what makes it open in a new window.
                    // );
                    if(obj.link_to_uid){
                        history.push('/online-store/'+obj.link_to_uid)
                    }
                    break;
                case 'checkin':
                    history.push('/scan')
                    break;
                case 'merchant_product':
                    let replace = obj.link_to_uid.replace(/'/g, '"');
                    let parsedPay =JSON.parse(replace);
                    let mallI = localStorage.getItem("mallId");
                    //window.location.href = `https://www.digimaall.com/malls/${mallI}/merchants/${parsedPay.merchant_uid}/products/${parsedPay.product_uid}`
                    // window.open(
                    //     `https://${window.location.host}/download/${mallI}/merchants/${parsedPay.merchant_uid}/products/${parsedPay.product_uid}`,
                    //     '_blank' // <- This is what makes it open in a new window.
                    // );
                    if(parsedPay.merchant_uid && parsedPay.product_uid){
                        history.push(`/online-store-product/${parsedPay.merchant_uid}/${parsedPay.product_uid}`)
                    }
                    break;
                case 'merchant_category_without_subcategory':
                    history.push('/store')
                    break;
                case 'mall_food_court':
                    history.push('/store',{catLink:{uid:obj.link_to_uid}})
                    break;
                case 'credit_package':
                    history.push('/reward')
                    break;
                case 'mall_parking':
                    history.push('/store')
                    break;
                case 'mall_event_details':
                    history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    // history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    break;
                case 'merchant_menu':
                    //history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    break;
                case 'live':
                    livePreview(obj)
                    break;
                case 'call_center':
                    let local_user = localStorage.getItem("user")
                    let user_obj = JSON.parse(local_user)
                    let new_topic = obj.link_to_uid.replace("REPLACE",user_obj.uid)
                    history.push(`/chat/${new_topic}`)
                    break;
                default:
                    console.log("default")
            }
        }

        const livePreview = (obj)=>{
            // console.log("Live : ",obj)
            // set_liveSrc(obj.link_to_uid)
            window.open(obj.link_to_uid, "_blank") //t
            // set_modalSW(true)
            // set_live(true)
        }

        const showModal = () => {
            setIsCouponModalVisible(true);
        };

        const handleOk = () => {
            setIsCouponModalVisible(false);
        };

        const handleCancel = () => {
            setIsCouponModalVisible(false);
        };

        const handleLiveOk = () => {
            set_live(false);
            set_modalSW(false)
        };

        const handleLiveCancel = () => {
            set_live(false);
            set_modalSW(false)
        };

        function convertTypeToRoute(type){
            switch(type){
                case 'home':
                    return "/home"
                    break;
                case 'services':
                    return "/services"
                    break;
                case 'store':
                    return "/store"
                    break;
                case 'blogpost':
                    return "/blogs"
                    break;
                case 'rewards':
                    return "/reward"
                    break;
                default:
                    return "/home"
            }
        }


        return (
            <div className="home-container" style={{overflow:"hidden"}}>
                {modalSW? <Modal visible={live}  footer={null}   onOk={handleLiveOk} onCancel={handleLiveCancel}>
                    <div>
                        <ReactPlayer
                            controls={true}
                            width='100%'
                            height='100%'
                            url={liveSrc} />
                    </div>
                </Modal>:null}


                <Modal visible={isCouponModalVisible}  footer={null}   onOk={handleOk} onCancel={handleCancel}>
                    <div className="coupon-modal-container">
                        <div className="coupon-modal-header">
                            کوپن ها
                        </div>
                        <div className="coupon-modal-body">
                            <p>کوپن <span className="coupon_number">{coupon}</span> با موفقیت برای شما فعال شد , شما هم اکنون میتوانید  از این کوپن استفاده نمایید</p>
                        </div>
                    </div>
                </Modal>
                {/*<HomeHeader/>*/}
                {/*<br/>*/}
                {/*<br/>*/}
                {/*<div style={{marginTop:5}}></div>*/}
                {!preload ? <div className="new-home">
                    {/*<span>{Platform.UA}</span>*/}
                    {homi.map(item=>{
                        switch (item.section_type) {
                            case 'my_recent_merchant':
                                return (
                                    <MyRecentMerchant item={item}/>
                                )
                                break;
                            case 'video_content':
                                return (
                                    <VideoSec item={item}/>
                                )
                                break;
                            case 'audio_content':
                                return (
                                    <AudioSec item={item}/>
                                )
                                break;
                            case 'blog_sec':
                                return (
                                    <BlogSec item={item}/>
                                )
                                break;
                            case 'category_slider':
                                return (
                                    <CategorySliderSec item={item}/>
                                )
                                break;
                            case 'tag_banner':
                                return (
                                    <TagBannerSec item={item}/>
                                )
                                break;
                            case 'merchant_menu':
                                return (
                                    <MyRecentMerchantMenu item={item}/>
                                )
                                break;
                            case 'reward_list':
                                return (
                                    <RewardList item={item}/>
                                )
                                break;
                            case 'campaign_list':
                                return (
                                    <CampaignList item={item}/>
                                )
                                break;
                            case "mall_products":
                                return(
                                    <ProductRegal item={item}/>
                                )
                                break;
                            case 'multiple_banner':
                                return (
                                    <MultipleList item={item}/>
                                )
                                break;
                            case 'my_invoice_list':
                                return (
                                    <MyInvoiceList item={item}/>
                                )
                                break;
                            case 'slider':
                                return (
                                    <div>
                                        <Slider uid={item.uid} dispatch={LinkDispatcher} data={item.items}/>
                                    </div>
                                )
                                break;
                            case 'dual_bar':
                                return (
                                    <div className="block-pool" style={{order: 2}}>

                                        <div className="block-item-horizontal">
                                            <div className="wrapper" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                                {item.items[0] ?
                                                    <>
                                                        {/*<img src={item.items[0].image} alt=""/>*/}
                                                        <LazyImage type={'side'} src={item.items[0].image}/>
                                                        <span className="block-title">{item.items[0].title}</span>
                                                    </>
                                                    : null}
                                            </div>

                                            <div className="wrapper" onClick={() => LinkDispatcher(item.items[1].link_to,item.items[1])}>
                                                {item.items[1] ?
                                                    <>
                                                        {/*<img src={item.items[1].image} alt=""/>*/}
                                                        <LazyImage type={'side'} src={item.items[1].image}/>
                                                        <span className="block-title">{item.items[1].title}</span>
                                                    </>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                )
                                break;
                            case 'single_bar':
                                return (
                                    <div key={item.items[0].uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                        <>
                                            {/*<img  src={item.items[0].image} alt=""/>*/}
                                            <LazyImage type={'banner'} src={item.items[0].image}/>
                                            <span className="block-title">{item.items[0].title}</span>
                                        </>
                                    </div>
                                )
                                break;
                            case 'actual_size_banner':
                                return (
                                    <ActualSec item={item} link={LinkDispatcher}/>
                                )
                                break;
                            case 'single_banner':
                                return (
                                    <div key={item.items[0].uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                        <>
                                            {/*<img  src={item.items[0].image} alt=""/>*/}
                                            <LazyImage type={'banner'} src={item.items[0].image}/>
                                            <span className="block-title">{item.items[0].title}</span>
                                        </>
                                    </div>
                                )
                                break;
                            case 'triad_big_right':
                                return (
                                    <div className="block-container">
                                        {/*left*/}
                                        {/*{left.title?<div className="block-pool" style={{order: 1}}>*/}
                                        {/*    <div className="block-item-vertical">*/}
                                        {/*        <div className="wrapper" onClick={() => LinkDispatcher(left.link_to,left)}>*/}
                                        {/*            <img src={left.image} alt="" />*/}
                                        {/*            <span className="block-title">{left.title}</span>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="block-item-vertical">*/}

                                        {/*        <div className="wrapper" onClick={() => LinkDispatcher(right_top.link_to,right_top)}>*/}
                                        {/*            <img src={right_top.image} alt=""/>*/}
                                        {/*            <span className="block-title">{right_top.title}</span>*/}
                                        {/*        </div>*/}
                                        {/*        <div className="wrapper" onClick={() => LinkDispatcher(right_bottom.link_to,right_bottom)}>*/}
                                        {/*            <img src={right_bottom.image} alt=""/>*/}
                                        {/*            <span className="block-title">{right_bottom.title}</span>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*</div>:null}*/}

                                        {/*right*/}
                                        {right.image?<div className="block-pool" style={{order: 1}}>
                                            <div className="block-item-vertical">
                                                <div className="wrapper" onClick={() => LinkDispatcher(right_top.link_to,right_top)}>
                                                    <img className="max-height" src={right_top.image} alt=""/>
                                                    <span className="block-title">{right_top.title}</span>
                                                </div>
                                                <div className="wrapper" onClick={() => LinkDispatcher(right_bottom.link_to,right_bottom)}>
                                                    <img  className="max-height" src={right_bottom.image} alt=""/>
                                                    <span className="block-title">{right_bottom.title}</span>
                                                </div>
                                            </div>
                                            <div className="block-item-vertical">
                                                <div className="wrapper" onClick={() => LinkDispatcher(right.link_to,right)}>
                                                    <img src={right.image} alt=""/>
                                                    <span className="block-title">{right.title}</span>
                                                </div>
                                            </div>
                                        </div>:null}


                                        {/*{dual_bar.length>0?*/}
                                        {/*    <div className="block-pool" style={{order: 2}}>*/}
                                        {/*        <div className="block-item-horizontal">*/}
                                        {/*            <div className="wrapper" onClick={() => LinkDispatcher(dual_bar[0].link_to,dual_bar[0])}>*/}
                                        {/*                {dual_bar[0] ?*/}
                                        {/*                    <>*/}
                                        {/*                        <img src={dual_bar[0].image} alt=""/>*/}
                                        {/*                        <span className="block-title">{dual_bar[0].title}</span>*/}
                                        {/*                    </>*/}
                                        {/*                    : null}*/}
                                        {/*            </div>*/}
                                        {/*            <div className="wrapper" onClick={() => LinkDispatcher(dual_bar[1].link_to,dual_bar[1])}>*/}
                                        {/*                {dual_bar[1] ?*/}
                                        {/*                    <>*/}
                                        {/*                        <img src={dual_bar[1].image} alt=""/>*/}
                                        {/*                        <span className="block-title">{dual_bar[1].title}</span>*/}
                                        {/*                    </>*/}
                                        {/*                    : null}*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*:null}*/}
                                    </div>
                                )
                                break;
                            case 'triad_big_left':
                                return (
                                    <div className="block-container">
                                        {/*left*/}
                                        {left.image?<div className="block-pool" style={{order: 1}}>
                                            <div className="block-item-vertical">
                                                <div className="wrapper" onClick={() => LinkDispatcher(left.link_to,left)}>
                                                    <img src={left.image} alt="" />
                                                    <span className="block-title">{left.title}</span>
                                                </div>
                                            </div>
                                            <div className="block-item-vertical">

                                                <div className="wrapper" onClick={() => LinkDispatcher(left_top.link_to,left_top)}>
                                                    <img  className="max-height" src={left_top.image} alt=""/>
                                                    <span className="block-title">{left_top.title}</span>
                                                </div>
                                                <div className="wrapper" onClick={() => LinkDispatcher(left_bottom.link_to,left_bottom)}>
                                                    <img className="max-height"   src={left_bottom.image} alt=""/>
                                                    <span className="block-title">{left_bottom.title}</span>
                                                </div>
                                            </div>
                                        </div>:null}

                                        {/*right*/}
                                        {/*{right.title?<div className="block-pool" style={{order: 1}}>*/}
                                        {/*    <div className="block-item-vertical">*/}
                                        {/*        <div className="wrapper" onClick={() => LinkDispatcher(right.link_to,right)}>*/}
                                        {/*            <img src={right.image} alt=""/>*/}
                                        {/*            <span className="block-title">{right.title}</span>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    <div className="block-item-vertical">*/}
                                        {/*        <div className="wrapper" onClick={() => LinkDispatcher(left_top.link_to,left_top)}>*/}
                                        {/*            <img src={left_top.image} alt=""/>*/}
                                        {/*            <span className="block-title">{left_top.title}</span>*/}
                                        {/*        </div>*/}
                                        {/*        <div className="wrapper" onClick={() => LinkDispatcher(left_bottom.link_to,left_bottom)}>*/}
                                        {/*            <img src={left_bottom.image} alt=""/>*/}
                                        {/*            <span className="block-title">{left_bottom.title}</span>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*</div>:null}*/}


                                        {/*{dual_bar.length>0?*/}
                                        {/*    <div className="block-pool" style={{order: 2}}>*/}
                                        {/*        <div className="block-item-horizontal">*/}
                                        {/*            <div className="wrapper" onClick={() => LinkDispatcher(dual_bar[0].link_to,dual_bar[0])}>*/}
                                        {/*                {dual_bar[0] ?*/}
                                        {/*                    <>*/}
                                        {/*                        <img src={dual_bar[0].image} alt=""/>*/}
                                        {/*                        <span className="block-title">{dual_bar[0].title}</span>*/}
                                        {/*                    </>*/}
                                        {/*                    : null}*/}
                                        {/*            </div>*/}
                                        {/*            <div className="wrapper" onClick={() => LinkDispatcher(dual_bar[1].link_to,dual_bar[1])}>*/}
                                        {/*                {dual_bar[1] ?*/}
                                        {/*                    <>*/}
                                        {/*                        <img src={dual_bar[1].image} alt=""/>*/}
                                        {/*                        <span className="block-title">{dual_bar[1].title}</span>*/}
                                        {/*                    </>*/}
                                        {/*                    : null}*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*:null}*/}
                                    </div>
                                )
                                break;

                            case 'button_list':
                                return (
                                    <div className="digi_badg_actions">
                                        {item.items.map(itemz => {
                                            return (
                                                <div key={itemz.uid} className="digi_badg_actions_item" onClick={()=>{ LinkDispatcher(itemz.link_to,itemz)}}>
                                                    <img src={itemz.image} alt="" style={{width: 48}}/>
                                                    <span>{itemz.title}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                                break;
                        }
                    })}
                </div> : <div className="customer-preLoading">
                    {!failed ? <div className="customer-preloading-body">
                        <img src="/svg/pre.gif" alt=""/>
                    </div> : <div className="customer-failed-body">
                        <img src="/svg/failed.svg" alt=""/>
                        <span>اطلاعاتی موجود نیست</span>
                    </div>}
                </div>}


                <Nav/>
            </div>
        )
    }catch (e) {
        console.log('Error');
    }
}

export default InnerLand;


